import { useToast as useChakraToast } from '@chakra-ui/react';
import { Toast } from './toast';
import { ToastProps } from './toast.types';

type UseToastReturn = {
  showToast: (props: ToastProps) => void;
};

export function useToast(): UseToastReturn {
  const chakraToast = useChakraToast();
  const closeToast = chakraToast.closeAll;
  return {
    showToast: (props): void => {
      chakraToast({
        position: 'top-right',
        duration: 2000,
        isClosable: false,
        render: () => <Toast closable={false} onClose={closeToast} {...props} />
      });
    }
  };
}
